import { AssignedAdvisorModel } from '../advisor/advisor.model';

export interface ClientProfilePictureModel {
  userId: string;
  profilePictureUrl: string | null;
}

export class ClientModel {
  userId: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  mvpConnected: boolean;
  consentAccepted: boolean;
  email: string;
  registered: string;
  /** True when the client self-registered with a valid advisor PIN — acquired through Vinlivt, not pool-imported. */
  registeredViaAdvisorPin: boolean | null;
  mainAdvisorUserId: string;
  mandateState: 'NO_SIGNATURE' | 'PENDING' | 'APPROVED' | 'POOL_MANDATE_SIGNED' | 'EXTERNAL_MANDATE_SIGNED';
  analysisPercent: number | null;
  selected?: boolean = false;
}

export class ClientDetailsModel {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePictureUrl: string;
  birthDate: string;
  taxId: string;
  poolIdentifier: string;
  onboardingPending: boolean;
  lastLogin: Date;
  /** Single-use code (3 letters + 3 digits) the client enters during app registration to claim this record (FIN-7053). */
  registrationCode: string;
  assignedAdvisors: AssignedAdvisorModel[];
  poolLink: string;
  address: AddressDetailsModel = new AddressDetailsModel();
  mandateState: 'NO_SIGNATURE' | 'PENDING' | 'APPROVED' | 'POOL_MANDATE_SIGNED' | 'EXTERNAL_MANDATE_SIGNED';
  accessReason:
    | 'MAIN_ADVISOR'
    | 'SECONDARY_ADVISOR'
    | 'SUBORDINATE_MAIN_ADVISOR'
    | 'SUBORDINATE_SECONDARY_ADVISOR'
    | 'DELEGATED_ACCESS';
}

export class AddressDetailsModel {
  street: string;
  houseNumber: string;
  zip: string;
  city: string;
  country?: string = 'DE';
  addressSupplement?: string;
}

export class ShortClientDetailsModel {
  userId: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
}
